import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { m } from "@vega-core/paraglide/messages";

type CollaboratorsSideDrawerHeaderV2Props = {
  isEditing: boolean;
  isSaveDisabled?: boolean;
  onManageRoles: () => void;
  onCancel: () => void;
  onSave: () => void;
};

export const CollaboratorsSideDrawerHeaderV2 = ({
  isEditing,
  isSaveDisabled,
  onManageRoles,
  onCancel,
  onSave,
}: CollaboratorsSideDrawerHeaderV2Props) => (
  <div className="flex justify-end gap-2">
    {isEditing ? (
      <>
        <ThemedButton
          dataTestId="cancel-manage-roles-button"
          onClick={onCancel}
          type="button"
          variant="tertiary"
        >
          {m.common_cancel()}
        </ThemedButton>
        <ThemedButton
          dataTestId="save-role-changes-button"
          disabled={isSaveDisabled}
          onClick={onSave}
          type="button"
        >
          {m.common_saveChanges()}
        </ThemedButton>
      </>
    ) : (
      <ThemedButton
        dataTestId="manage-roles-button"
        onClick={onManageRoles}
        type="button"
        variant="secondary"
      >
        {m.settings_collaborators_manageRoles()}
      </ThemedButton>
    )}
  </div>
);
